<template>
  <b-modal
    :id="id"
    size="lg"
    centered
  >
    <template #modal-header="{ close }">
      <h5 class="modal-title">Bill Service History</h5>
      <a class="close" @click="close()"><i class="far fa-times-circle fa-2x"></i></a>
    </template>
    <div class="container-fluid no-pad">
      <div v-if="loading" class="text-center my-4">
        <b-spinner label="Loading history"></b-spinner>
      </div>
      <div v-else-if="error" class="text-center my-4 text-danger">
        Unable to load the Bill Service history. Please try again.
      </div>
      <div v-else-if="!changes.length" class="text-center my-4">
        No Bill Service changes have been recorded.
      </div>
      <div v-else class="table-responsive history-scroll">
        <table class="table table-sm history-table mb-0">
          <thead>
            <tr>
              <th>Date</th>
              <th>User</th>
              <th>Bill Service</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(change, index) in changes"
              :key="change.AuditId || index"
            >
              <td>{{ formatDateTime(change.ChangedUtc) }}</td>
              <td>{{ change.ChangedByName || change.ChangedBy }}</td>
              <td>{{ change.DoNotBill ? 'Excluded' : 'Included' }}</td>
              <td class="reason-cell">{{ change.Reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <template #modal-footer="{ cancel }">
      <button type="button" class="btn btn-hc" @click="cancel()">Cancel</button>
    </template>
  </b-modal>
</template>

<script>
import moment from 'moment';

// Read-only Bill Service history pop-up (SEBL-0041-B 3.1.2). Opened from the History
// hyperlink on the Bill Service line. Rows (including system updates) are supplied by the
// parent from the ContractBot audit endpoint, already newest-first.
export default {
  name: 'DoNotBillHistoryModal',

  props: {
    id: {
      type: String,
      default: 'donotbill-history-modal',
    },
    changes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    formatDateTime(value) {
      return value ? moment(value).format('DD/MM/YY') : '';
    },
  },
};
</script>

<style scoped>
.history-scroll {
  max-height: 40vh;
  overflow-y: auto;
}

.history-table thead th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}

.history-table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.reason-cell {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
